














































































import { computed, defineComponent } from '@vue/composition-api';
import State, { ActionState } from '../../global/ActionState.vue';
import { useStore } from '../../../composables';
import { CtaBanner } from '../../base';
import { APrimaryBtn } from '../../base/app/buttons';
import moment from 'moment';
import { ShareholderService } from '@ligo/dashboard/customer/store';

export default defineComponent({
  name: 'ShareholdersHandler',
  components: {
    CtaBanner,
    State,
    APrimaryBtn
  },
  setup() {
    const store = useStore();
    const notaryProduct = store.getters['notaryProduct/getNotaryProduct'];

    const shareholders = computed(() => notaryProduct.shareholders);

    const state = computed<ActionState | string>(() => {
      const regularShareholders =
          shareholders.value?.filter(shareholder => !shareholder.foreign_incorporator);

      if (!regularShareholders.length)
        return 'completed';

      if (regularShareholders.every(shareholder => shareholder.verified))
        return 'completed';
      if (regularShareholders.some(shareholder => shareholder.verified))
        return 'in_progress';

      return 'todo';
    });

    function canResendEmail(shareholder) {
      if (!shareholder.last_verification_sent_at) return true;
      const sendingTime = moment(shareholder.last_verification_sent_at);
      const currentTime = moment();
      const hoursDiff = currentTime.diff(sendingTime, 'hours');
      return hoursDiff > 1;
    }

    function lastEmailSentAt(shareholder) {
      if (!shareholder.last_verification_sent_at) return null;
      return moment(shareholder.last_verification_sent_at).format(
        'DD/MM/YYYY HH:mm'
      );
    }

    function sendVerificationEmail(shareholder) {
      ShareholderService.sendVerificationEmail(shareholder.id)
        .then(() => {
          shareholder.last_verification_sent_at = new Date();
        })
        .catch((error) => {
          console.error('Error sending verification email:', error);
        });
    }

    return {
      shareholders,
      state,
      lastEmailSentAt,
      canResendEmail,
      sendVerificationEmail
    };
  }
});
